// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';
import MessageList from '../views/MessageList.vue';
import MessageDetail from '../views/MessageDetail.vue';
import JoinMember from '@/views/JoinMember.vue';

// 路由配置数组
const routes = [
  {
    path: '/',
    name: 'index',
    component: Home
  },
  {
    path: '/home',
    name: 'home',
    component: Home
  },
  {
    path: '/message-list',
    name: 'messageList',
    component: MessageList
  }
  ,
  {
    path: '/article-detail',
    name: 'articleDetail',
    component: MessageDetail
  }
  ,
  {
    path: '/join-member',
    name: 'joinMember',
    component: JoinMember
  },
  {
    path: '/branch-offices',
    name: 'BranchOffices',
    component: () => import('@/views/BranchOffices.vue'),
    meta: {
      title: '广州分会联系方式'
    }
  }
];

// 创建路由实例并传递 `routes` 配置
const router = createRouter({
  history: createWebHistory(), // 使用 HTML5 的 history 模式
  routes
});

export default router;
